import { useState, useEffect } from "react";
import SVGStar from "../../assets/svgComponents/Star";
import { useUser } from "../../contexts/useUserData";
import { sendFavQuestions, deleteFavQuestion } from "../../api";
import styles from "./favStyles.module.css";
import { Popup } from "semantic-ui-react";
import { useMediaQuery } from "@react-hook/media-query";
import "semantic-ui-css/semantic.min.css";
import { useLayout } from "../../contexts/useLayoutContext";

interface propsData {
    index: number;
    question: string;
    signalPopup: Function;
    closePopup: boolean;
}

export const ButtonFav = (props: propsData) => {
    const [fillStar, setFillStar] = useState<string>("#FFFF");
    const [statusStar, setStatusStar] = useState<boolean>(false);
    const [statusPopup, setStatusPopup] = useState<boolean>(false);
    const { menuOpen } = useLayout();
    const { favQuestions, pushFavQuestions, removeOneFavQuestion, scope, token, acceso } = useUser();
    const isResponsive = useMediaQuery("only screen and (max-width: 768px)");
    async function handleClick() {
        const buttonClickTime = Date.now();
        let final_token = "";
            if (token) {
                final_token = token;
            }
            
        if (!statusStar) {
            const payload = { 
                question: props.question, 
                scope: scope!, 
                acceso: acceso!, 
                ButtonClickTime: buttonClickTime
            };
            await sendFavQuestions(payload, final_token);
            pushFavQuestions!(props.question);
            setFillStar("#cbc7c7");
            setStatusStar(true);
        } else {
            setStatusPopup(!statusPopup);
            props.signalPopup(props.index);
        }
    }
    async function deleteOneQuestion(question: string, index: number) {
        await deleteFavQuestion({ question: question , scope: scope!, acceso:acceso!, ButtonClickTime: Date.now()});
        removeOneFavQuestion!(index);
    }
    function buttonClass() {
        if (!statusStar) {
            return styles.buttonFav;
        } else {
            return styles.buttonFavClicked;
        }
    }
    useEffect(() => {
        let match = false;
        favQuestions?.forEach(element => {
            if (element === props.question) match = true;
        });
        if (!match) {
            setFillStar("#FFFF");
            setStatusStar(false);
        } else {
            setFillStar("#cbc7c7");
            setStatusStar(true);
        }
    }, [favQuestions]);

    useEffect(() => {
        if (menuOpen) setStatusPopup(false);
    }, [menuOpen]);
    useEffect(() => {
        if (props.closePopup) setStatusPopup(false);
    }, [props.closePopup]);

    document.querySelector("main")!.onscroll = function () {
        if (statusPopup) setStatusPopup(false);
    };
    return (
        <Popup
            trigger={
                <button id={"button-fav"} type="button" className={buttonClass()} onClick={handleClick}>
                    <SVGStar fill={fillStar} />
                </button>
            }
            position={isResponsive ? "top left" : "right center"}
            on={"click"}
            open={statusPopup}
        >
            <div className={styles.confirmationContainer}>
                <p>¿Desea eliminar el favorito?</p>
                <div className={styles.confirmationButtons}>
                    <button
                        type="button"
                        onClick={() => {
                            setStatusPopup(false);
                        }}
                        className={styles.btnPrimary}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className={styles.btnDefault}
                        onClick={async () => {
                            const index: number = favQuestions!.findIndex(element => {
                                return element === props.question;
                            });
                            await deleteOneQuestion(props.question, index);
                            setFillStar("#FFFF");
                            setStatusStar(false);
                            setStatusPopup(false);
                        }}
                    >
                        Aceptar
                    </button>
                </div>
            </div>
        </Popup>
    );
};
